import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted, computed, watch } from 'vue'
    import useIframeControl from '@/hooks/iframeWebChatFull'
    import { useWebChatFullStore } from '@/stores/webChatFull'
    import services from '@/services'

    import PageLoading from './page/PageLoading.vue'
    import PageError from './page/PageError.vue'
    import PageLogin from './page/PageLogin.vue'
    import PageChat from './page/PageChat.vue'

    import { webchat } from '@/types/mountWidget'
    import { itemWebChatFull, CurrentComponent } from '@/types/webChatFull'

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeWebChatFull',
  setup(__props) {

    const components: { [key: string]: any } = {
        PageLoading,
        PageError,
        PageLogin,
        PageChat,
    }

    const iframe = useIframeControl()
    const webChatFullStore = useWebChatFullStore()

    const isComponent = ref('PageLoading')

    const isWebChatFull = computed(() => webChatFullStore.me)

    function handleError (error: Error) {
        console.warn(error)
        webChatFullStore.setCurrentComponent('error')
    }

    function handleSelectComponent (user : string | null = null) {

        if (user === null) {
            webChatFullStore.setCurrentComponent('login')
            return
        }
        webChatFullStore.setCurrentComponent('chat')
    }

    function formatWebChatFull( data : webchat ) : itemWebChatFull {
        let payload = {
            ...isWebChatFull.value,
            apiId: data.api_id,
            data: data.webchat,
            businessId: data.business_id,
            channel: data.channel_id,
            attendance: {
                id: data.attendance,
                unreadMessages: 0,
            }
        }

        if(data.user) payload.user = data.user
        if(data.token) payload.wsToken = data.token

        if(data.client) {
            payload.name = data.client.name
            payload.email = data.client.email
        }
        return payload
    }

    async function handleMountWebChat() {
        try {

            const response = await services.webchat.mount({
                device: window.navigator.userAgent,
                apiKey: isWebChatFull.value.apiKey,
                page: isWebChatFull.value.currentPage,
                user: isWebChatFull.value.user,
                email: isWebChatFull.value.email,
                custom_token: isWebChatFull.value.custom_token,
                name: isWebChatFull.value.name,
            })

            if (response?.errors) {

                let component = 'error' as CurrentComponent
                if(response.errors.error === 'NotParamInformedException') {
                    // notify.error('Não foi possível carregar o chat, tente novamente mais tarde.')
                    component = 'login'
                }
                webChatFullStore.setCurrentComponent(component)
                return
            }

            const payload = formatWebChatFull(response.data)
            webChatFullStore.update(payload)
            handleSelectComponent(response.data.user)
        } catch (error) {
            handleError(error as Error)
            webChatFullStore.setCurrentComponent('error')
        }
    }

    watch(() => isWebChatFull.value.currentComponent, (newComponent) => {
        const componentMapping : Record<string, string> = {
            'error': 'PageError',
            'login': 'PageLogin',
            'chat': 'PageChat'
        }

        isComponent.value = componentMapping[newComponent] || 'PageLoading';

    },{deep: true})

    onMounted(async () => {
        iframe.updateCoreValuesOnStore()
        // webChatFullStore.setCurrentComponent('chat')
        await handleMountWebChat()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(components[isComponent.value]), { key: isComponent.value }))
}
}

})